var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CallSupport } from '@/components/call-support.component';
import { palette } from '@/theme/palette';
import { Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
import { FaRegQuestionCircle } from 'react-icons/fa';
export function DinTestSidePanel() {
    var sendButtonClick = useAnalytics().sendButtonClick;
    return (_jsxs("div", __assign({ className: "flex flex-col justify-between h-full bg-faux-black p-10" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-5" }, { children: [_jsx(FaRegQuestionCircle, { color: "white" }), _jsx(Typography, __assign({ className: "text-white text-left text-lg" }, { children: "We will play 3 numbers with background noise." })), _jsx(Typography, __assign({ className: "text-white text-left text-lg" }, { children: "Enter the numbers you hear in the order you hear them and press SUBMIT." })), _jsx(Typography, __assign({ className: "text-white text-left text-lg" }, { children: "If you can't hear the numbers clearly, enter your best guess." }))] })), _jsx(CallSupport, { onClick: function () { return sendButtonClick('test_support'); }, iconColor: palette.primary.main, classes: {
                    iconClass: 'bg-white',
                    textClass: 'text-white flex flex-col leading-none gap-1',
                    containerClass: 'ml-8',
                } })] })));
}
